export default {
  login: 'GİRİŞ YAP',
  waitLogin: 'GİRİŞ YAPILIYOR',
  logout: 'Çıkış Yap',
  forgot: 'ŞİFREMİ GÖNDER',
  reset: 'ŞİFREMİ OLUŞTUR',
  resetHeader: 'Şifremi Oluştur',
  emailOrPhone: 'E-Posta Adresi veya Telefon Numarası',
  email: 'E-posta',
  password: 'Şifre',
  passwordAgain: 'Şifre Tekrar',
  messages: {
    login: 'Lütfen giriş yapınız',
    forgot: 'Şifre Al / Şifremi Unuttum',
    onlyForgot: 'Şifremi Unuttum',
    reset: 'Şifremi Güncelle',
    logging: 'Giriş Yapılıyor...',
  },
};
